import { utils } from 'cesg-shared';
import { buildStorageKey } from './storage-service';

export class LocalStorageService<State extends object> {
  //TODO: Uppdatera så vi inte sparar usern i plain text utan sparar ner JWT. I payloaden sparar vi roller och permissions.
  protected _stateKey: string;
  protected _defaultStateInitiator: () => State;

  constructor(key: string, defaultStateInitiator: () => State) {
    this._stateKey = buildStorageKey(key);
    this._defaultStateInitiator = defaultStateInitiator;
  }
  protected setState(state?: Partial<State>): State {
    const stateToUse = Object.assign(this.getState(), state ?? {});
    localStorage.setItem(this._stateKey, JSON.stringify(stateToUse));
    return stateToUse;
  }

  protected getState(): State {
    const state = localStorage.getItem(this._stateKey);
    const stateOrUndefined = utils.type.isString(state)
      ? utils.json.parseOrDefault(state, undefined)
      : undefined;
    return stateOrUndefined ?? this._defaultStateInitiator();
  }
}
